<template>
  <div class="p-l-5 animate__animated animate__fadeIn">
    <div class="pull-left m-t-5 m-b-5">
      <h4 class="m-b-0">
        {{ title }}
      </h4>
      <p class="small hint-text">
        {{ subTitle }}
      </p>
    </div>
    <div class="clearfix" />
    <loader-component v-if="data == null" />
    <div v-else id="linechartdualaxis" />
  </div>
</template>

<script>
import $ from "jquery";
import Highcharts from "highcharts/highcharts.js";
import moment from "moment";
import loader_component from "@/views/components/loader.vue";

export default {
  name: "line_chart_dual_axis",
  props: {
    title: String,
    subTitle: String,
    data: Object,
  },
  components: {
    "loader-component": loader_component,
  },
  data() {
    return {
      data_chart: this.data,
    };
  },
  methods: {
    loadChart: function () {
      var data = this.data_chart;
      let self = this;
      if (data != null) {
        var config = {
          chart: {
            type: "spline",
            backgroundColor: "transparent",
            height: 300,
          },
          credits: {
            enabled: false,
          },
          title: {
            text: "",
          },
          xAxis: [
            {
              categories: data.date,
              crosshair: true,
            },
          ],
          yAxis: [
            {
              labels: {
                format: "{value}",
              },
              title: {
                text: "Mention",
              },
            },
            {
              labels: {
                format: "{value}",
              },
              title: {
                text: "Reach",
              },
              opposite: true,
            },
          ],
          tooltip: {
            shared: true,
          },
          legend: {
            layout: "horizontal",
            align: "center",
            verticalAlign: "bottom",
          },
          plotOptions: {
            series: {
              label: {
                connectorAllowed: false,
              },
              point: {
                events: {
                  click: function () {
                    let start = "";
                    let end = "";
                    let params = {};
                    if (moment(this.category).isValid()) {
                      start = moment(this.category).format(
                        "YYYY-MM-DD 00:00:00"
                      );
                      end = moment(this.category).format("YYYY-MM-DD 23:59:59");
                    } else {
                      let start_jam = this.category + ":00";
                      let end_jam = this.category.replace("00", "59") + ":59";
                      start = moment(self.$route.query.from).format(
                        "YYYY-MM-DD " + start_jam
                      );
                      end = moment(self.$route.query.to).format(
                        "YYYY-MM-DD " + end_jam
                      );
                    }

                    params = {
                      from: start,
                      to: end,
                    };

                    if ("topic" in self.$route.query) {
                      params.topic = self.$route.query.topic;
                    }

                    self.$router.push({ path: "/posts", query: params });
                  },
                },
              },
            },
            line: {
              events: {
                legendItemClick: function () {
                  if (this.name != "Mention") {
                    this.chart.yAxis[1].axisTitle.attr({
                      text: this.name,
                    });
                  }
                  var series = this.chart.series;
                  for (var i = 0; i < series.length; i++) {
                    if (
                      series[i].index != this.index &&
                      series[i].name != "Mention"
                    ) {
                      series[i].hide();
                    }
                  }
                },
              },
            },
          },
          series: [
            {
              name: "Mention",
              data: data.mention,
              color: $("body").css("--purple"),
            },
            {
              name: "Reach",
              data: data.reach,
              color: $("body").css("--orange"),
              yAxis: 1,
            },
            {
              name: "Engagement",
              data: data.engagement,
              color: $("body").css("--cyan"),
              yAxis: 1,
              visible: false,
            },
          ],
        };
        new Highcharts.chart("linechartdualaxis", config);
      }
    },
  },
  mounted: function () {
    if (this.data_chart != null) {
      this.loadChart();
    }
  },
};
</script>